import React from "react";

const PRIORITY_COLORS = {
  Critical: "bg-red-500/15 text-red-300 border-red-500/30",
  High: "bg-orange-500/15 text-orange-300 border-orange-500/30",
  Medium: "bg-amber-500/15 text-amber-300 border-amber-500/30",
  Low: "bg-emerald-500/15 text-emerald-300 border-emerald-500/30",
};

const STATUS_COLORS = {
  Open: "bg-sky-500/15 text-sky-300 border-sky-500/30",
  "In Progress": "bg-violet-500/15 text-violet-300 border-violet-500/30",
  "On Hold": "bg-zinc-500/20 text-zinc-300 border-zinc-500/30",
  Completed: "bg-emerald-500/15 text-emerald-300 border-emerald-500/30",
  Closed: "bg-zinc-700/40 text-zinc-300 border-zinc-600/40",
};

export function Pill({ kind = "priority", value, testid }) {
  if (!value) return <span className="text-zinc-600 text-xs">—</span>;
  const map = kind === "status" ? STATUS_COLORS : PRIORITY_COLORS;
  const cls = map[value] || "bg-white/5 text-zinc-300 border-white/10";
  return (
    <span
      className={`inline-flex items-center gap-1.5 px-2 py-0.5 rounded-full text-[11px] font-medium border ${cls}`}
      data-testid={testid}
    >
      <span className="w-1 h-1 rounded-full bg-current opacity-80" />
      {value}
    </span>
  );
}

export default Pill;
